export default __webpack_public_path__ + "static/media/quick_transport_logo.410e6d6c.svg";